import React from "react";
import { Container, Row, Col } from "reactstrap";
import "../../styles/about-section.css";
import aboutImg from "../../assets/all-images/cars-img/bmw-offer.png";

const AboutSection = ({ aboutClass }) => {
  return (
    <section
      className="about__section"
      style={
        aboutClass === "aboutPage"
          ? { marginTop: "0px" }
          : { marginTop: "100px" }
      }
    >
      <Container>
        <Row>
          <Col lg="6" md="6">
            <div className="about__section-content">
              <h4 className="section__subtitle">Sobre nosotros</h4>
              <h2 className="section__title">Bienvenido a DedeaMotor</h2>
              <p className="section__description">
                Encuentra el coche de tus sueños al mejor precio, con toda la garantía de calidad y sin complicaciones. En nuestro concesionario, no solo vendemos coches, ¡vendemos tranquilidad! Nos encargamos de todas las gestiones necesarias para que puedas conducir tu nuevo coche en el menor tiempo posible, y siempre con la seguridad de que has tomado la mejor decisión.
              </p>

              <div className="about__section d-flex justify-content-around">
                <div className="about__section-item">
                  <p className="section__description d-flex align-items-center gap-2">
                    <i className="ri-checkbox-circle-line"></i> Precios competitivos.
                  </p>
                  <p className="section__description d-flex align-items-center gap-2">
                    <i className="ri-checkbox-circle-line"></i> Atención personalizada.
                  </p>
                </div>

                <div className="about__section-item">
                  <p className="section__description d-flex align-items-center gap-2">
                    <i className="ri-checkbox-circle-line"></i> Garantías de calidad.
                  </p>
                  <p className="section__description d-flex align-items-center gap-2">
                    <i className="ri-checkbox-circle-line"></i> Servicio integral.
                  </p>
                </div>
              </div>
            </div>
          </Col>

          <Col lg="6" md="6">
            <div className="about__img">
              <img src={aboutImg} alt="" className="w-100" />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default AboutSection;
